<template>
  <main>
    <section>
      <v-row no-gutters class="d-flex justify-center">
        <v-flex xs12 md6 lg6>
          <v-card flat style="margin-left: 2%" class="px-8 pt-6">
            <v-tabs
              class="mb-8"
              v-model="tab"
              show-arrows
              background-color="transparent"
              color="primary"
              left
            >
              <v-tab v-for="item in items" :key="item">
                {{ item }}
              </v-tab>
            </v-tabs>
            <h1 class="h1_class">
              Study of Investigational Drug for Narcolepsy
            </h1>
            <v-tabs-items v-model="tab" class="mr-6">
              <v-tab-item>
                <div>
                  <p style="font-size: 12px; color: #444444">
                    Theia Clinical Research in St. Petersburg, FL has been
                    chosen as the trial site by the study sponsor Axsome
                    Therapeutics, Inc. It is located in the Pasadena Center for
                    Asthma and Lung Disorders.
                  </p>
                  <p style="font-size: 12px; color: #444444">
                    Site Address: 5454 Central Ave, Ste. A, St Petersburg, FL
                    33707
                  </p>
                  <div>
                    <iframe
                      width="100%"
                      height="100%"
                      frameborder="0"
                      style="border: 0"
                      src="https://www.google.com/maps/embed/v1/place?key=AIzaSyCNdmanRmiS_QCVNfp6ReOJsh0CB0Ra2_U
    &q=5454 Central Ave, Ste. A, St Petersburg, FL 33707"
                    >
                    </iframe>
                  </div>
                  <p style="font-size: 12px; color: #444444">
                    Phone:727-225-2728
                  </p>
                  <p style="font-size: 12px; color: #444444">
                    <b
                      >Further information about the study can be found in the
                      sponsor page:</b
                    >
                    Detailed NIH approval information regarding this trial can
                    be found in the
                    <a
                      href="https://clinicaltrials.gov/ct2/show/NCT03881852"
                      target="_blank"
                      >Clinical Trials page</a
                    >
                  </p>
                </div>
              </v-tab-item>
              <v-tab-item>
                <v-card flat>
                  <p style="font-size: 12px; color: #444444">
                    The purpose of this clinical study is to test the efficacy
                    and safety of a drug in adults who have been diagnosed with
                    narcolepsy. Study participants receive study-related medical
                    exams and study drug at no cost. Compensation for time and
                    travel may be available.
                  </p>

                  <div class="mt-5">
                    <h5
                      class="mb-5"
                      style="font-size: 14px; font-weight: bold; color: #444444"
                    >
                      Why Are We Conducting This Study
                    </h5>
                    <p style="font-size: 12px; color: #444444">
                      This is a randomized study, double-blind
                      placebo-controlled, multicenter study of oral AXS-12
                      (Reboxetine) for patients with narcolepsy.
                    </p>
                  </div>

                  <div class="mt-5">
                    <h5
                      class="mb-5"
                      style="font-size: 14px; font-weight: bold; color: #444444"
                    >
                      Who Can Participate In This Study
                    </h5>
                    <p style="font-size: 12px; color: #444444">
                      Patients who have been diagnosed with narcolepsy can
                      participate in this study. Please submit your contact
                      information if you or a person in your care meet the
                      criteria below:
                    </p>
                    <ul
                      class="my-6 ml-4"
                      style="font-size: 12px; color: #444444"
                    >
                      <li>Between the ages of 15-75</li>
                      <li>Diagnosed with narcolepsy</li>
                      <li>Experiencing attacks of cataplexy</li>
                    </ul>
                    <p style="font-size: 12px; color: #444444">
                      Other criteria for eligibility may apply.
                    </p>
                  </div>
                </v-card>
              </v-tab-item>
              <v-tab-item>
                <v-card flat>
                  <p style="font-size: 12px; color: #444444">
                    Narcolepsy is a chronic sleep disorder.
                  </p>
                  <p style="font-size: 12px; color: #444444">Symptoms:</p>
                  <ul class="my-6 ml-4" style="font-size: 12px; color: #444444">
                    <li>Excessive daytime sleepiness</li>
                    <li>Sudden loss of muscle tone</li>
                    <li>Sleep paralysis</li>
                  </ul>
                  <p style="font-size: 12px; color: #444444">and more.</p>
                </v-card>
              </v-tab-item>
              <!--              <v-tab-item>-->
              <!--                <v-card flat>-->
              <!--                  <div class="mt-5">-->
              <!--                      <h5 class="mb-5">-->
              <!--                        <a-->
              <!--                            href="https://www.businesswire.com/news/home/20201124006087/en/European-Commission-Approves-Janssen%E2%80%99s-TREMFYA%C2%AE%E2%96%BC-guselkumab-a-First-in-Class-Treatment-for-Active-Psoriatic-Arthritis-PsA"-->
              <!--                            target="_blank"-->
              <!--                        >-->
              <!--                          European Commission Approves Janssen’s TREMFYA®▼ (guselkumab), a First-in-Class Treatment for Active Psoriatic Arthritis (PsA)-->
              <!--                        </a>-->
              <!--                      </h5>-->
              <!--                      <p>-->
              <!--                        Guselkumab is the first approved fully human monoclonal antibody that selectively binds to the p19 subunit of interleukin (IL)-23 and inhibits its interaction with the IL-23 receptor. It is already approved for the treatment of patients with moderate to severe plaque psoriasis. IL-23 is an important driver of the progression of inflammatory diseases including psoriasis and PsA, among others...<a-->
              <!--                          href="https://www.businesswire.com/news/home/20201124006087/en/European-Commission-Approves-Janssen%E2%80%99s-TREMFYA%C2%AE%E2%96%BC-guselkumab-a-First-in-Class-Treatment-for-Active-Psoriatic-Arthritis-PsA"-->
              <!--                      >Read More</a-->
              <!--                      >-->
              <!--                      </p>-->
              <!--                    </div>-->
              <!--                </v-card>-->
              <!--              </v-tab-item>-->
            </v-tabs-items>
          </v-card>
        </v-flex>
        <v-flex xs12 md6 class="align-center justify-center form-background">
          <v-layout align-center justify-center>
            <v-card class="mt-16 trail-detail-card pa-1">
              <div class="flex-column flex-row">
                <v-spacer style="flex-grow: 0.6 !important"></v-spacer>
                <v-card-text class="pa-8">
                  <v-row no-gutters justify="center">
                    <h3 class="text-md-center ml-3 mb-3 m-text-black">
                      (Static Page Form Not to be Filled) <br />
                      Sign up for the trials now
                    </h3>
                  </v-row>
                  <v-form ref="form" lazy-validation>
                    <v-container fluid class="pl-lg-3 pl-sm-0 pr-lg-3 pl-sm-0">
                      <v-row no-gutters>
                        <v-text-field
                          outlined
                          label="Name"
                          validate-on-blur
                          v-model="userData.name"
                          :rules="nameRules"
                        >
                        </v-text-field>
                      </v-row>
                      <v-row no-gutters>
                        <v-text-field
                          outlined
                          label="Email"
                          validate-on-blur
                          v-model="userData.email"
                          :rules="emailRules"
                        >
                        </v-text-field>
                      </v-row>
                      <v-row no-gutters>
                        <v-text-field
                          outlined
                          label="Phone"
                          validate-on-blur
                          v-model="userData.phone"
                          :rules="phoneRules"
                          hint="Length must be between 7 to 15 characters"
                        >
                        </v-text-field>
                      </v-row>
                      <v-row no-gutters>
                        <v-textarea
                          auto-grow
                          outlined
                          label="Other Medical Conditions"
                          @focus="addFirstBullet()"
                          validate-on-blur
                          v-model="clientDetails"
                          @keydown.enter.prevent="addBullet()"
                          @keydown.delete="countBullets()"
                          hint="Insert upto three points"
                        >
                        </v-textarea>
                      </v-row>
                    </v-container>
                    <v-row no-gutters justify="center">
                      <v-btn
                        class="submit-btn"
                        rounded
                        color="primary"
                        :loading="submitting"
                        :disabled="true"
                        >Submit</v-btn
                      >
                    </v-row>
                  </v-form>
                </v-card-text>
                <v-spacer></v-spacer>
              </div>
            </v-card>
          </v-layout>
        </v-flex>
      </v-row>
    </section>
  </main>
</template>

<script>
export default {
  name: "AdTrialDetails",
  props: {
    id: String,
  },
  async created() {
    // await this.$store.dispatch("get", { trialId: this.id });
  },
  data() {
    return {
      tab: 0,
      items: ["Sponsor & Site Info", "About the Study", "About Narcolepsy"],
      userData: {
        study_id: "xxx",
        name: "",
        email: "",
        phone: "",
        data: {},
        // any other fields as necessary
      },
      nameRules: [(v) => !!v || "Name is required"],
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
      ],
      phoneRules: [
        (v) => !!v || "Phone number is required",
        (v) =>
          (v.length >= 7 && v.length <= 11) ||
          "Length must be between 7 and 11 digits",
      ],
      clientDetails: "",
      numOfLinesInData: 0,
      submitting: false,
      error: false,
      errorMessage: undefined,
    };
  },
  methods: {
    addFirstBullet() {
      if (this.clientDetails === "") {
        this.clientDetails = this.clientDetails + "\u2022 ";
      }
      this.numOfLinesInData = this.countBullets();
    },
    countBullets() {
      let count = 0,
        i = 0;
      for (i = 0; i <= this.clientDetails.length; i++) {
        if (this.clientDetails[i] == "\u2022") {
          count++;
        }
      }
      return count;
    },
    addBullet() {
      if (this.countBullets() < 3) {
        if (
          this.clientDetails.length == 0 ||
          this.clientDetails[this.clientDetails.length - 1] == ""
        ) {
          this.clientDetails = this.clientDetails + "\u2022 ";
        } else {
          this.clientDetails = this.clientDetails + "" + "\u2022 ";
        }
        this.numOfLinesInData = this.countBullets();
      }
    },
    clearUserData() {
      (this.userData.name = ""),
        (this.userData.email = ""),
        (this.userData.phone = ""),
        (this.userData.data = {}),
        (this.clientDetails = "");
    },
    // async submitForm() {
    //   if (this.$refs.form.validate()) {
    //     let detailsData = new FormData();
    //     let i = 0;
    //     let stripData = this.clientDetails.replaceAll("", "");
    //     let splitData = stripData.split("\u2022");
    //     for (i = 1; i <= this.numOfLinesInData; i++) {
    //       detailsData.append("issue".concat(i.toString()), splitData[i]);
    //     }
    //     let clientDetailsObject = {};
    //     detailsData.forEach((value, key) => (clientDetailsObject[key] = value));
    //     this.userData.data = clientDetailsObject;
    //     try {
    //       this.submitting = true;
    //       await this.$store.dispatch("submitClientData", {
    //         userData: this.userData
    //       });
    //     } catch (e) {
    //       this.error = true;
    //       this.errorMessage = JSON.stringify(e);
    //       console.log(e);
    //     } finally {
    //       this.submitting = false;
    //     }
    //     // await this.$router.push("/trials");
    //     this.clearUserData();
    //     this.$notify({
    //       group: "submissionSuccesful",
    //       title: "Data Submission Successful",
    //       text:
    //         "Thank you. Your information has been sent.",
    //       duration: 5000
    //     });
    //   }
    // }
  },
  computed: {
    trial() {
      return this.$store.state.trialMap[this.id];
    },
  },
};
</script>

<style lang="scss">
@import "@/scss/_colors";

.trial-detail {
  //min-height: calc(80vh);
  background-color: #ffff;
}
@media screen and (min-width: 800px) {
  .form-background {
    min-height: 90vh;
    background: url("~@/assets/trails_form_bg.svg") !important;
    background-size: cover;
  }
}

.my-style {
  .notification-title {
    color: white;
    background-color: deepskyblue;
    text-align: center;
  }

  .notification-content {
    color: white;
    background-color: deepskyblue;
    text-align: center;
  }
}

//.m-trial-detail-page {
//  margin-top: 80px;
//}
.trial-content {
  margin-top: 50px;
  margin-bottom: 50px;

  p {
    color: $text;
    font-size: 16px;
    text-align: justify;
  }
  li {
    font-size: 16px;
    margin-top: 15px;
  }
}
.trail-detail-card {
  box-shadow: 4px 4px 10px rgba(0, 0, 0, 0.25);
  border-radius: 20px !important;
  //min-height: 400px;
  width: 480px;

  @media (max-width: 600px) {
    //min-width: 100vw;
    //height: 100vh;
  }
  .v-card-title {
    padding-bottom: 5px;
  }
  .v-input--checkbox {
    .v-label {
      margin-bottom: 0;
    }
  }
  .theme--light.v-btn:hover::before {
    opacity: 0;
  }
}
.m-text-black {
  text-decoration-color: #424649 !important;
}
.submit-btn {
  min-width: 200px !important;
}
</style>
